<div class="row container-form-list mb-4">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">Usuários que possuem acesso e visibilidade a unidade de negócio</h6>
                <small class="card-subtitle mb-0">Adicione os usuários que devem ter acesso e visibilidade a unidade de negócio {{nomeUnidadeNegocio}}</small>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th class="col-options"></th>
                            <th class="col-usuario-nome">Usuário</th>
                            <th class="col-usuario-perfil">Perfil</th>
                            <th class="col-usuario-email">E-mail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-options">
                                <a (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-usuario-nome">
                                <sgt-typeahead-usuario [(ngModel)]="entity.usuario"  name="usuario_{{i}}" id="usuario_{{i}}"
                                    #usuario="ngModel" #typeaheadUsuario [ngControl]="usuario" [ativos]="true" container="body" [dropup]="i > 5"
                                    (typeaheadChange)="onChangeUsuario(entity, $event)">
                                </sgt-typeahead-usuario>
                            </td>
                            <td class="col-usuario-perfil">
                                {{entity.usuario?.perfil | usuarioPerfil}}
                            </td>
                            <td class="col-usuario-email">
                                {{entity.usuario?.login}}
                            </td>                            
                        </tr>
                        <tr *ngIf="entities && entities.length === 0" class="no-record">
                            <td class="text-center" colspan="2">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> <span class="d-none d-sm-inline-block ml-1"> Adicionar usuário</span>
                </button>
                <button type="button" class="btn btn-light btn-sm" (click)="openUsuarioPopulaAgrupamentoPerfilModal()">
                    <i class="fas fa-bolt" aria-hidden="true"></i> <span class="d-none d-sm-inline-block ml-1"> Adicionar vários usuários</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal para popular os usuários -->
<sgt-usuario-popula-agrupamento-perfil-modal
    #usuarioPopulaAgrupamentoPerfilModal
    title="Adicionar acesso e visibilidade a unidade de negócio"
    [subtitle]="getSubtitleUsuarioPopulaAgrupamentoPerfilModal()"
    [entitiesAdicionadas]="entities"
    (adicionar)="onAdicionarUsuarios($event)">
</sgt-usuario-popula-agrupamento-perfil-modal>